(function($) {
	$.fn.track = function(fn, $container, once) {

		var data = {

			// remove listeners after one apparition?
			one: !!once,
  			
  			// number of apparitions
			count: 0
		};
		
		var offsets = {};
		
		var w = $(window);
		
		$container = $container || w;
		
		if(!offsets.top)
			offsets.top = 0;
			
		if(!offsets.bottom)
			offsets.bottom = 0;		
			
		//console.log(this);

		return this.each(function() {
			
			//console.log('scroll');

			var t = $(this);

			//whether the element is currently visible
			t.appeared = false;

			//fires the appear event when appropriate
			var check = function(e) {

				//is the element hidden?
				if (!t.is(':visible')) {

					//it became hidden
					t.appeared = false;
					return;
				}

				//is the element inside the visible window?
				var b = w.scrollTop();
				var y = t.offset().top;
				
				var th = t.outerHeight();
				var wh = w.height();
				
				var hh = th/2;
				var boxTop = offsets.top - hh;
				var boxBottom = wh - offsets.bottom + hh;
				
				var progress = 1 - (y+hh-b - boxTop) / (boxBottom - boxTop),
					percent = Math.max(Math.min(progress, 1), 0) *100;
				
				if( fn ){
					fn.bind(this)(e, {
						percent: percent,
						top: y - b - offsets.top,
						wheight: wh,
						height: th
					});
				}

				t.trigger('track', [{
					percent: percent,
					top: y - b - offsets.top
				}]);

				if (progress <= 1 && progress > 0) {

					//trigger the custom event
					if (!t.appeared){
						data.count++;
						//console.log(t, progress)
						t.trigger('appear', data.count);
					}

				} else {
				
					//console.log(progress)
				
					if(t.appeared) // it scrolled out of view
						t.trigger('disappear', data.count);
					
					t.appeared = false;
				}
			};

			//create a modified fn with some additional logic
			var modifiedFn = function() {

				//mark the element as visible
				t.appeared = true;

				//is this supposed to happen only once?
				if (data.one) {

					//remove the check
					$container.unbind('scroll', check);
					w.unbind('gc:draw', check);
				}
			};

			//bind the modified fn to the element
			if (data.one) t.one('appear', modifiedFn);
			else t.bind('appear', modifiedFn);

			//check whenever the window scrolls
			$container.scroll(check);
			
			// also whenever we like
			w.on('gc:draw', check);

			//check now
			(check)();
		});
	};
	
	$.fn.viewportClass = function( cls, $container ) {
		return this.each(function() {
			$(this).on('appear', function(e){
				$(this).addClass(cls);
			})
			.on('disappear', function(e){
				$(this).removeClass(cls);
			})
			.track(null, $container, false);
		});
	};

})(require('jquery'));


//////////////////
// WEBPACK FOOTER
// ./themes/gc/js/track.js
// module id = 11
// module chunks = 0